import { render, staticRenderFns } from "./StudentSchool.vue?vue&type=template&id=56f452b8&"
import script from "./StudentSchool.js?vue&type=script&lang=js&"
export * from "./StudentSchool.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports